module.exports = __webpack_public_path__ + "static/images/info-brand.ee4521798d77912868c3deb48f926bcc.svg";